import React from "react";
import { StepItem as StepItemType } from "./types";
import StepItem from "./StepItem";

interface StepListProps {
  steps: StepItemType[];
  theme?: "light" | "dark";
}

function StepList({ steps, theme }: StepListProps) {
  return (
    <div className="w-full flex flex-col md:flex-row gap-6 justify-start">
      {steps.map((step, idx) => (
        <StepItem
          key={step.title}
          number={idx + 1}
          title={step.title}
          description={step.description}
          theme={theme}
        />
      ))}
    </div>
  );
}

export default StepList;
